import { render, staticRenderFns } from "./left-right-container.vue?vue&type=template&id=07338f0f&scoped=true&"
import script from "./left-right-container.vue?vue&type=script&lang=js&"
export * from "./left-right-container.vue?vue&type=script&lang=js&"
import style0 from "./left-right-container.vue?vue&type=style&index=0&id=07338f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07338f0f",
  null
  
)

component.options.__file = "left-right-container.vue"
export default component.exports